/**************************************************
 * Nombre:       Inicio_Capacitaciones_Disponibles
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import Tarjeta_Capacitaciones from "../../Tarjetas/Tarjeta_Capacitaciones";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {usuarioContext} from "../../../App";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {
    obtenerPorcentajeTodasCalificaciones
} from "../../../CodigoNegocio/Capacitaciones/obtenerPorcentajeTodasCalificaciones";
import {verificarObligatorias} from "../../../CodigoNegocio/Capacitaciones/verificarObligatorias";

const Inicio_Capacitaciones_Disponibles = () => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const [capacitaciones, setCapacitaciones] = useState([]);
    const [capacitacionObligatorias, setCapacitacionObligatorias] = useState([]);
    const [calificaciones, setCalificaciones] = useState([]);
    const [promedioGlobal, setPromedioGlobal] = useState(0);
    const [obligatoriasHechas, setObligatoriasHechas] = useState(false);


    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'capacitaciones', wheres: w}).then((dox) => {
            let arrObligatorias = dox.data.filter(dox => dox.obigatoria === 'Si')
            let arrCapacitacion = dox.data.filter(dox => dox.obigatoria === 'No' || dox.obigatoria === undefined)
            setCapacitaciones(arrCapacitacion)
            setCapacitacionObligatorias(arrObligatorias)

            let wCal = [where('idUsuario', '==', cData.usuario.id)]
            obtenerColWheres({col: 'calificaciones', wheres: wCal}).then((des) => {
                setCalificaciones(des.data);
                setPromedioGlobal(obtenerPorcentajeTodasCalificaciones(des.data));
                setObligatoriasHechas(verificarObligatorias(des.data, arrObligatorias))
            })


        })





    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{color: '#262626'}}
                    spacing={0}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: sCell ? 32 :  36, fontWeight: sCell ? 700 : 800, lineHeight: 1.1, textAlign: sCell ? 'center' : 'left'}}>Capacitaciones disponibles</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent:  'flex-start', mt: sCell ? 2 : 1}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400, textAlign: sCell ? 'center' : 'left'}}>
                            Explora las capacitaciones que hemos preparado para impulsar tu crecimiento personal y
                            empresarial.
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-end'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={6}
                >

                    {capacitacionObligatorias.map((it, index) => (
                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Capacitaciones item={it} calificaciones={calificaciones} disponibles={true}/>
                        </Grid>
                    ))}

                </Grid>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-end'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={6}
                >

                    {capacitaciones.map((it, index) => (
                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Capacitaciones item={it} calificaciones={calificaciones} disponibles={obligatoriasHechas}/>
                        </Grid>
                    ))}

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Inicio_Capacitaciones_Disponibles

const capacitaciones = [
    {
        nombre: 'Documento Uno',
    },
    {
        nombre: 'Documento Dos',
    },
    {
        nombre: 'Documento Tres',
    },
    {
        nombre: 'Documento Cuatro',
    },
]